import { CardActionArea as MuiCardActionArea, CardMedia as MuiCardMedia } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import type { IMerchant } from "@framework/types";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import { Card, Typography } from "@dzambalaorg/ui-kit";

interface IMerchantListItemProps {
  merchant: IMerchant;
}

export const MerchantListItem = (props: IMerchantListItemProps) => {
  const { merchant } = props;

  return (
    <MuiCardActionArea component={RouterLink} to={`/marketplace/merchants/${merchant.id}`}>
      <Card
        header={
          <Card.Header
            title={<MuiCardMedia image={merchant.imageUrl} title={`${merchant.title}`} />}
            subheader={<Typography variant="h5">{merchant.title}</Typography>}
          />
        }
      >
        <Card.Content>
          <Typography variant="body2" color="textSecondary" component="div">
            <RichTextDisplay data={merchant.description} />
          </Typography>
        </Card.Content>
      </Card>
    </MuiCardActionArea>
  );
};
